import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../styles/Sidebar.css";
import { useSelector } from "react-redux";

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = useSelector((_) => _?.login);
  const project_list = userDetails?.actions?.projects?.project_list;
  const client_list = userDetails?.actions?.clients?.client_list;
  const employee_list = userDetails?.actions?.employees?.employee_list;
  const invoice_list = userDetails?.actions?.invoices?.invoice_list;
  // debug: show invoice_list permission in console
  console.debug("Sidebar permissions - invoice_list:", invoice_list);
  // NOTE: link is shown only when `invoice_list` permission exists.
  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("userData");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("builtPermissionsV1");
    navigate("/login");
    console.log("Logging out...");
  };

  const location1 = useLocation();

  const Color = location1?.pathname == "/profile" ? "text-primary" : null;
  console.log(Color);

  const getActiveLink = (path) => {
    const currentPath = location.pathname;

    return currentPath.startsWith(`/${path}`) ? "text-primary" : "text-muted";
  };

  return (
    <div className="custom-sidebar">
      <div className="sidebar-header">
        <Link to="/">
          <img
            src="/assets/images/logo.png"
            alt="Logo"
            className="sidebar-logo"
          />
        </Link>
      </div>

      <ul className="sidebar-nav">
        <li>
          <Link to="/dashboard" className={`nav-link ${getActiveLink("dashboard")}`}>
          <i className="bi bi-speedometer2 sidebar-icon"></i>
            <span>Dashboard</span>
          </Link>
        </li>
         <li>
          <Link to="/my-timesheet" className={` nav-link ${!Color ?getActiveLink("my-timesheet"): Color }`}>
          <i className="bi bi-currency-exchange sidebar-icon"></i>
            <span>My Timesheet</span>
          </Link>
        </li>
        {/* <li>
          <Link to="#" className={`nav-link ${getActiveLink("expenses")}`}>
          <i className="bi bi-currency-exchange sidebar-icon"></i>
            <span>Expenses</span>
          </Link>
        </li> */}
        {/* <li>
          <Link to="#" className={`nav-link ${getActiveLink("leave")}`}>
          <i className="bi bi-suitcase-lg-fill sidebar-icon"></i>
            <span>Leave</span>
          </Link>
        </li> */}
        {project_list && (
          <li>
            <Link
              to="/projects"
              className={`nav-link ${getActiveLink("project")}`}
            >
              <i className="bi bi-kanban-fill sidebar-icon"></i>
              <span>Projects</span>
            </Link>
          </li>
        )}
        {client_list && (
          <li>
            <Link
              to="/clients"
              className={`nav-link ${getActiveLink("clients")}`}
            >
              <i className="bi bi-building-fill sidebar-icon"></i>
              <span>Clients</span>
            </Link>
          </li>
        )}
        {employee_list && (
          <li>
            <Link
              to="/employees"
              className={`nav-link ${getActiveLink("employees")}`}
            >
              <i className="bi bi-people-fill sidebar-icon"></i>
              <span>Employees</span>
            </Link>
          </li>
        )}
        {invoice_list && (
          <li>
            <Link to="/invoices" className={`nav-link ${getActiveLink("invoices")}`}>
              <i className="bi bi-receipt-cutoff sidebar-icon"></i>
              <span>Invoices</span>
            </Link>
          </li>
        )}
        <li>
          <Link
            to="/settings"
            className={`nav-link ${getActiveLink("settings")}`}
          >
            <i className="bi bi-gear-fill sidebar-icon"></i>
            <span>Settings</span>
          </Link>
        </li>
        <li>
          <Link
            onClick={logout}
            className={`nav-link ${getActiveLink("logout")}`}
          >
            <i className="bi bi-box-arrow-left sidebar-icon"></i>
            <span>Logout</span>
          </Link>
        </li>
      </ul>

      <footer className="app-footer text-center" style={{ marginTop: "80px" }}>
        <span>
          © {new Date().getFullYear()} ProjeX. All rights reserved. · Version{" "}
          {process.env.REACT_APP_RELEASE_VERSION}
        </span>
      </footer>
    </div>
  );
}

export default Sidebar;
